import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableItem({ id, thumbUrl, name }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: "120px",
    height: "213px", // ✅ 9:16 proporcija
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: "#fff",
    overflow: "hidden",
    margin: "5px",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <img
        src={thumbUrl}
        alt={name}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
}

function AlbumOrderManager({ albumName }) {
  const [wallpapers, setWallpapers] = useState([]);

  // 🔥 Učitavanje wallpapera
  useEffect(() => {
    let q;

    if (albumName === "EDITOR'S PICK") {
      // ✅ Učitaj i sa i bez apostrofa
      q = query(
        collection(db, "wallpapers"),
        where("albums", "array-contains-any", ["EDITOR'S PICK", "EDITORS PICK"]),
        orderBy("order", "asc")
      );
    } else {
      q = query(
        collection(db, "wallpapers"),
        where("albums", "array-contains", albumName),
        orderBy("order", "asc")
      );
    }

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setWallpapers(data);
    });

    return () => unsubscribe();
  }, [albumName]);

  // 🔄 Drag-and-drop
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = wallpapers.findIndex((item) => item.id === active.id);
      const newIndex = wallpapers.findIndex((item) => item.id === over.id);
      const newItems = arrayMove(wallpapers, oldIndex, newIndex);
      setWallpapers(newItems);

      // Sačuvaj novi redosled u Firestore
      for (let i = 0; i < newItems.length; i++) {
        const ref = doc(db, "wallpapers", newItems[i].id);
        await updateDoc(ref, { order: i + 1 });
      }
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Redosled za album: {albumName}</h2>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={wallpapers.map((wp) => wp.id)}
          strategy={rectSortingStrategy}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(8, 120px)", // ✅ 8 po redu
              gap: "10px",
            }}
          >
            {wallpapers.map((wp) => (
              <SortableItem
                key={wp.id}
                id={wp.id}
                thumbUrl={wp.thumbUrl}
                name={wp.name}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
}

export default AlbumOrderManager;
